module.exports = [{
      plugin: require('../../../node_modules/gatsby-plugin-manifest/gatsby-browser.js'),
      options: {"plugins":[],"name":"dispensary-medtrail-website","short_name":"medtrail","start_url":"/","background_color":"#F78765","theme_color":"#F78765","display":"minimal-ui","icon":"static/favicon.ico"},
    },{
      plugin: require('../gatsby-browser.js'),
      options: {"plugins":[]},
    }]
